import { render, staticRenderFns } from "./LineBorder.vue?vue&type=template&id=709ab018&scoped=true&"
import script from "./LineBorder.vue?vue&type=script&lang=js&"
export * from "./LineBorder.vue?vue&type=script&lang=js&"
import style0 from "./LineBorder.vue?vue&type=style&index=0&id=709ab018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ab018",
  null
  
)

export default component.exports